import request from '@/utils/request';
import {
  getWelcomePackChallenge,
  signRewardClaimMessage,
} from '@/api/welcome-pack';

/**
 * 领取体验金 POST /liyuan-trade/wallet/trial/claim（须钱包 / Privy personal_sign）
 * @param {{ amount: number|string }} body
 * @returns {Promise<{ txHash?: string, balance: number|string, mintStatus?: 'pending'|'confirmed' }>}
 */
export async function claimTrialFund(body) {
  const amount = body?.amount;
  const challenge = await getWelcomePackChallenge({
    purpose: 'TRIAL',
    amount,
  });
  const signed = await signRewardClaimMessage(
    challenge?.message,
    challenge?.address
  );
  return request.post(
    '/liyuan-trade/wallet/trial/claim',
    {
      amount,
      address: signed.address,
      message: signed.message,
      signature: signed.signature,
    },
    {
      timeout: 45000,
    }
  );
}

/**
 * 查询兑换/提现达标条件 GET /liyuan-trade/wallet/trial/withdraw-conditions
 * @param {{ currentWithdrawAmount?: number|string }} [params]
 * @returns {Promise<TrialConditionsVo>}
 */
export function getTrialWithdrawConditions(params = {}) {
  const query = {};
  if (params.currentWithdrawAmount != null && params.currentWithdrawAmount !== '') {
    query.currentWithdrawAmount = String(params.currentWithdrawAmount);
  }
  return request.get('/liyuan-trade/wallet/trial/withdraw-conditions', query);
}
